export const environment = {
  production: true,
  apiUrl: 'https://hostmx.app1.lacteosmojica.com/public/api',
  //apiUrlCore: 'https://ts.lacteosmojica.cloud:9090/kepler-app/api',
  apiUrlCore: 'http://201.151.177.74:9101/api',
  userManualUrl: 'https://help.app.lacteosmojica.com'
};
